export enum PaymentStatus {
    Failed = "FAILED",
    Paid = "PAID",
    Pending = "PENDING"
}